import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CloseAction } from 'pages/conversations/ui/ConversationList/ui/BulkActions/CloseAction/CloseAction'
import { ReadAction } from 'pages/conversations/ui/ConversationList/ui/BulkActions/ReadAction/ReadAction'
import { DropdownActions } from 'pages/conversations/ui/ConversationList/ui/BulkActions/DropdownActions/DropdownActions'
import styles from './styles.module.scss'

export const BulkActions = observer(() => {
  const { usersStore } = useEntitiesContext()
  const user = usersStore.user

  if (user?.isViewOnlyRole) return null

  return (
    <div className={styles.wrap}>
      <CloseAction />
      <ReadAction />
      <DropdownActions />
    </div>
  )
})
